var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('assistant-comp'),_c('message-comp'),_c('message-box')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }